import type * as Koala from '@getkoala/browser';

import { isClient } from '#/utils/general';

/**
 * Get the Koala SDK from the global window object.
 *
 * @returns the Koala SDK
 */
export function getKoala(): Koala.KoalaSDK | null {
  if (!isClient()) {
    return null;
  }

  // @ts-expect-error: This is not typed
  // biome-ignore lint/style/noNonNullAssertion: This is a client-side only code.
  return window.ko!;
}
